/**3.0最新请求方式**/
import axios from "axios";

axios.defaults.baseURL = "https://new.schoolpi.net/api";
axios.defaults.timeout = 30000;

// axios.interceptors.request.use(config => {
//     if (config.method === 'post') {
//         config.data = {
//             ...config.data,
//         }
//     } else if (config.method === 'get') {
//         config.params = {
//             ...config.params,
//         }
//     }
//     // 在最后必须 return config
//     return config
// },
//     error => {

//         if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {

//         }
//     });
// //返回拦截器
// axios.interceptors.response.use(response => {
//     if (response.data.code === -1) {
//         // Router.replace({
//         //     path: '/menu/menu',
//         // })
//     }
//     return response
// });
//get请求
export const httpGet = function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}
//post请求
export const httpPost = function post(url, data = {}) {
    
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}